import React from 'react';
import './AboutSection.css';
import { useNavigate } from 'react-router-dom';
import { CREDIT_UNION } from '../../assets/constants';

const AboutSection = () => {
  const navigate = useNavigate();
    const handleApplyNow = () => {
    localStorage.removeItem('current_guid');
    localStorage.removeItem('form_data');
    sessionStorage.clear();
    navigate('/ApplicationForm');
  };
  
  return (
    <section className="about-section" role="region" aria-labelledby="about-heading">
      <div className="layout-container">
        <h2 id="about-heading" className="about-heading">
          About {CREDIT_UNION.INFO.NAME}
        </h2>
        <p className="about-text">
          {CREDIT_UNION.ABOUT.TEXT}
        </p>

        <div className="about-btn-wrapper">
          <a
            href="/ApplicationForm"
            className="about-btn"
            role="button"
            aria-label="Apply now for refinancing"
            onClick={handleApplyNow}
          >
            APPLY NOW
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
